import { Button } from '@guildeducationinc/recess';
import { useMediaQuery } from 'react-responsive';
import { MOBILE_QUERY, SALESFORCE_NEW_REQUEST_URL } from '@src/constants';
import ActionCard from '@shared/ActionCard/ActionCard';
import ActionCardButtons from '@shared/ActionCard/ActionCardButtons';
import ActionCardContent from '@shared/ActionCard/ActionCardContent';
import { clickable } from '@src/analytics';

export const CallCoachAction = () => {
  const isMobile = useMediaQuery(MOBILE_QUERY);
  const icon = {
    src:
      'https://guild.imgix.net/student-home/programs-and-applications/catalog-coach-recommendations-circle.svg',
    alt: 'Get Recommendations',
  };

  const buttonText = 'learn_skills_message_support';

  return (
    <ActionCard icon={icon}>
      <ActionCardContent
        estimate='2 MIN'
        title='Get recommendations.'
        body='Guild has a lot of learning programs to offer. Make it easier to decide with personalized program recommendations from a Guild Specialist.'
      />
      <ActionCardButtons>
        <Button
          fullWidth={isMobile}
          href={SALESFORCE_NEW_REQUEST_URL}
          target='_blank'
          newWindowIcon={true}
          newWindowNotification={true}
          onClick={() => {
            clickable({
              product: 'home',
              loggedIn: true,
              tag: 'learn_skills',
              text: buttonText,
              type: 'link',
              external_url: SALESFORCE_NEW_REQUEST_URL,
            });
          }}
        >
          Message Support
        </Button>
        <Button
          appearance='outline'
          fullWidth={isMobile}
          className={isMobile ? 'margin--top_8' : 'margin--left_24'}
          onClick={() => {
            clickable({
              product: 'home',
              loggedIn: true,
              tag: 'learn_skills',
              text: 'call_number',
              type: 'button',
            });

            window.location.replace('tel:18009854027');
          }}
        >
          Call 1-800-985-4027
        </Button>
      </ActionCardButtons>
    </ActionCard>
  );
};
